import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import { componentStyles } from "./person-component.scss";
import { trackCommunityEvent } from "/services/bigbrain-service";
import { SHOW_TEMPLATES } from "/constants/bigbrain-event-types";
class PersonComponent extends PureComponent {
    trackLinkClick(event) {
        const { target } = event;
        const href = target.href || target.parentElement.href; /* For Logo image*/ 
        const isUser = href.indexOf("/user/") != -1;
        const id = href.substring(href.lastIndexOf("/") + 1);
        trackCommunityEvent(SHOW_TEMPLATES, {
            kind: isUser ? "user" : "account",
            info1: id
        });
    }
    render() {
        const { personName, personImageSrc, personUrl, vendorName, vendorUrl, namePrefix, postfix } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "person-component",
            children: [
                personImageSrc && /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "person-image",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: personImageSrc,
                        alt: personName,
                        className: `jsx-${componentStyles.__hash}`
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "text-container",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: `jsx-${componentStyles.__hash}` + " " + "name-and-vendor-container text",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: `jsx-${componentStyles.__hash}`,
                                children: namePrefix
                            }),
                            personUrl && /*#__PURE__*/ _jsx("a", {
                                href: personUrl,
                                onClick: this.trackLinkClick,
                                className: `jsx-${componentStyles.__hash}` + " " + "person-name",
                                children: personName
                            }),
                            !personUrl && /*#__PURE__*/ _jsx("span", {
                                className: `jsx-${componentStyles.__hash}` + " " + "person-name",
                                children: personName
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: `jsx-${componentStyles.__hash}`,
                                children: " from "
                            }),
                            vendorUrl && /*#__PURE__*/ _jsx("a", {
                                href: vendorUrl,
                                onClick: this.trackLinkClick,
                                className: `jsx-${componentStyles.__hash}` + " " + "vendor-name",
                                children: vendorName
                            }),
                            !vendorUrl && /*#__PURE__*/ _jsx("span", {
                                className: `jsx-${componentStyles.__hash}` + " " + "vendor-name",
                                children: vendorName
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: `jsx-${componentStyles.__hash}` + " " + "story text",
                                children: postfix
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { PersonComponent as default };
PersonComponent.defaultProps = {
    personName: "",
    personImageSrc: "",
    personUrl: "",
    vendorName: "",
    vendorUrl: "",
    namePrefix: "Hi I'm ",
    postfix: "This is how I use monday.com"
};
